export default __webpack_public_path__ + "static/media/Sky-Rocket_DAO_2.09f5f845.mp4";